import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { DataTable } from 'components';
import { DataTableRef } from 'components/tables/data-table';
import { fetchContractsList } from 'services/contracts';
import { Contract, Role } from 'types';

import { useAuth, useSelectedLocation } from 'contexts';
import { useMemo, useRef, useState } from 'react';
import { downloadCsv } from 'services/download-csv';
import { contractDataColumns } from './contract-list.context';
import ContractMigrationDialog from './migration/contract-migration-dialog';

const Contracts = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const { selectedLocation } = useSelectedLocation();
  const tableRef = useRef<DataTableRef>(null);
  const [migrationOpen, setMigrationOpen] = useState(false);

  const initialColumns = useMemo(() => {
    return userProfile.columnPreferences.filter(cp => cp.table === 'CONTRACT').length > 0
      ? userProfile.columnPreferences
          .filter(cp => cp.table === 'CONTRACT')
          .map(({ column, width }) => {
            return { field: column, width };
          })
      : contractDataColumns.map(({ field, width }) => {
          return { field, width };
        });
  }, [userProfile.columnPreferences]);

  const showMigration = userProfile.role === Role.ADMIN || userProfile.role === Role.BILLING_ADMIN;
  const canCreateContract = userProfile.role === Role.ADMIN || userProfile.role === Role.BILLING_ADMIN;

  return (
    <>
      <div className="page">
        <div className="page-header">
          <h1>CONTRACTS</h1>
          <div>
            {showMigration && (
              <Button
                variant="outlined"
                style={{ marginRight: 8 }}
                disabled={!selectedLocation}
                onClick={() => setMigrationOpen(true)}
              >
                Migration
              </Button>
            )}
            {canCreateContract && (
              <Button variant="contained" onClick={() => navigate('/contracts/new')}>
                New Contract
              </Button>
            )}
          </div>
        </div>
        {/* TODO server side quick filter */}
        <div className="page-content flex-grow-1">
          {/* List contracts */}
          <DataTable
            ref={tableRef}
            tableClass="t-height"
            fetchData={params => fetchContractsList({ ...params })}
            fetchCsv={downloadCsv('contracts')}
            filterByLocation
            columns={contractDataColumns}
            initialPage={{ pageNum: 0, pageSize: 100 }}
            onRowClick={(row: Contract) => navigate(`/contracts/${row.id}`)}
            initialColumns={initialColumns}
            enableSaveColumns="CONTRACT"
            showColumnsCategorized
          />
        </div>
      </div>
      <ContractMigrationDialog
        open={migrationOpen}
        location={selectedLocation}
        onClose={() => setMigrationOpen(false)}
        onSuccess={() => tableRef.current?.forceFetch()}
      />
    </>
  );
};

export default Contracts;
